import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import PurchaseDashboard from "./purchase-dashboard";

function PurchasePage() {

    return (
        <ToastProvider>
            <Dashboard>
                <PurchaseDashboard />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default PurchasePage